import TimeFeatureFlagContext from 'context/time-feature-flag';
import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { getEnvironment } from 'util/common';
import { ENVIRONMENTS } from 'util/constants';

const useTimeBasedFeatureFlag = (featureName) => {
    const context = useContext(TimeFeatureFlagContext);
    if (!context) {
        throw new Error('useTimeBasedFeatureFlag must be used within a TimeFlagProvider');
    }
    if (featureName) {
        return context.isFeatureEnabled(featureName);
    }
    return context;
};

const checkIsActiveTimeRange = ({ startTime, endTime, nowTime }) => {
    const now = nowTime ? new Date(nowTime).toISOString() : new Date().toISOString();
    const start = startTime ? new Date(startTime).toISOString() : null;
    const end = endTime ? new Date(endTime).toISOString() : null;

    if (start && end) {
        return now >= start && now <= end;
    }
    else if (start) {
        return now >= start;
    }
    else if (end) {
        return now <= end;
    }
    else {
        return true;
    }
};

// NOTE: Didn't want to check feature flag on an interval for every second, so checking it only when the location changes.
const TimeFlagProvider = ({ flags = FLAGS_CONFIG, children }) => {
    const location = useLocation();
    const [activeFlags, setActiveFlags] = useState([]);

    useEffect(() => {
        // Check which features are enabled based on the time or environment
        const updatedFlags = flags.map((flag) => ({
            ...flag,
            enabled: checkIsActiveTimeRange({ startTime: flag.startTime, endTime: flag.endTime })
        }));

        setActiveFlags(updatedFlags);
    }, [flags, location]);

    const isFeatureEnabled = (featureName) => {
        const flag = activeFlags.find((f) => f.name === featureName);
        return flag ? flag.enabled : false;
    };

    return (
        <TimeFeatureFlagContext.Provider value={{ isFeatureEnabled, flags: activeFlags }}>
            {children}
        </TimeFeatureFlagContext.Provider>
    );
};

const ENV = getEnvironment();
const isBetaOrProduction = ENV === ENVIRONMENTS.BETA || ENV === ENVIRONMENTS.PRODUCTION;

const FLAG_KEYS = {
    AG_1583: 'ag-1583'
};

const FLAGS_CONFIG = [
    {
        name: FLAG_KEYS.AG_1583,
        ...(isBetaOrProduction && { startTime: '2025-07-03T23:00:00Z' }) // 4PM 7/3/2025 PDT (daylight time)
    }
];

export { checkIsActiveTimeRange, useTimeBasedFeatureFlag as default, FLAG_KEYS, TimeFlagProvider };
